export default function PHP_realpath_cache_size() {
  return (
    <div>
      <h1>PHP_realpath_cache_size</h1>
    </div>
  );
}
